<template>
  <v-layout row>
    <v-flex xs12 sm8 offset-sm2 lg4 offset-lg4>
      <v-card class="mt-2 card-round card-login" rounded>
        <progress-bar :show="busy"></progress-bar>
        <v-card-title primary-title>
          <div class="form-title">
            <img src="/img/acma3.jpg" alt="alt" width="250" height="88" />
            <h3 class="title text-uppercase primary--text mb-0">Connexion</h3>
          </div>
        </v-card-title>
        <form @submit.prevent="login" @keydown="form.onKeydown($event)">
          <!-- <v-card-title primary-title>
            <h3 class="headline mb-0">{{ $t('login') }}</h3>
          </v-card-title> -->
          <v-card-text class="px-8">
            <div class="form-field">
              <label for="">Identifiant</label>
              <email-input :form="form" :label="$t('email')" :v-errors="errors" :value.sync="form.email" name="email"
                round v-validate="'required|email'"></email-input>
            </div>

            <div class="form-field">
              <label for="">Mot de passe</label>
              <password-input :v-errors="errors" :form="form" round hide-details :value.sync="form.password"
                v-validate="'required|min:8'"></password-input>


              <div class="pull-right py-0 d-flex px-2">
                <router-link class="password-forgotten info--text darken3" :to="{ name: 'password.request' }">
                  Mot de passe oublié?
                </router-link>
              </div>
            </div>

            <v-container fluid grid-list-md>
              <v-layout row align-center justify-space-between>

                <div>

                  <input type="checkbox" v-model="confirm" style="margin-right: 2px; ">
                  Vous acceptez nos <a target="_blank"
                    href="https://pga.acma2.org/politique-confidentialite-IFDC.html">politiques de confidentialité</a>
                  <p v-if="isConfirm" style="color: red;">Veuillez acceptez nos politiques de confidentialité pour continuer</p>
                </div>
              </v-layout>
            </v-container>
            <div class="form-actions my-8">

              <submit-button :form="form" small :label="'Se connecter'"></submit-button>
            </div>
            <v-container fluid grid-list-md>
              <v-layout row text-center>
                <v-flex fill-height mb-2>
                  <img src="/img/pays_bas_tiny.png" alt="Pays bas logo" width="100" height="38" />
                </v-flex>
              </v-layout>
              <v-layout row align-center justify-space-between>
                <div xs12 sm4 md4>
                  <img src="/img/ifdc.png" alt="logos partenaires" width="115" height="80" />
                </div>
                <div xs12 sm4 md4>
                  <img src="/img/care.png" alt="logos partenaires" width="100" height="80" />
                </div>
                <div xs12 sm4 md4>
                  <img src="/img/kit.png" alt="logos partenaires" width="80" height="70" />
                </div>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </form>
      </v-card>

    </v-flex>
    <v-flex xs12 sm8 offset-sm2 lg4 offset-lg4 q-mt-md>
      <div>
        <a style="text-decoration:none;color: #FFFFFF;" href="http://pga.acma2.org/terms-and-conditions.html"
          target="_blank" rel="noopener noreferrer">Conditions Générales d’Utilisation</a>

        <a style="text-decoration:none;color: #FFFFFF; margin-left: 12px;"
          href="http://pga.acma2.org/mentions-legales.html" target="_blank" rel="noopener noreferrer">Mentions
          Légales</a>
          <a style="text-decoration:none;color: #FFFFFF; margin-left: 12px;"
          href="https://pga.acma2.org/politique-confidentialite-IFDC.html#_Toc108606206" target="_blank" rel="noopener noreferrer">Politique de cookies
          </a>
      </div>
    </v-flex>
    <v-row justify="space-between">
      <v-dialog v-model="cookieConsent" persistent width="700">
        <v-card>
          <v-toolbar color="secondary" dark>
            Mention d'informations sur les cookies
          </v-toolbar>

          <v-list-item>
            <v-list-item-content>
              <div xs12 sm4 md4>
                <img src="/img/ifdc.png" alt="logos partenaires" width="120" height="80" />
              </div>
              <v-list-item-title class="text-h5 mb-1 ml-4 text-red">
                Cette mention est une exigence de l’Autorité de Protection des Données Personnelles du Bénin
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-card-text>
            Ce site utilise des cookies pour collecter des données auprès de nos utilisateurs. L’Utilisateur est informé
            que lors de ses visites sur l’Application, un cookie peut s’installer automatiquement sur son logiciel de
            navigation. <br>
            Cette collecte a pour finalité l’accès aux services de création et d’analyse des données sur le prix du marché
            des produits agroalimentaires. <br>
            Nous partageons les informations collectées avec notre partenaire <a href="https://ticagrobusiness.com"
              target="_blank" rel="noopener noreferrer">TIC AGRO BUSINESS CENTER</a>. <br>
            Les données collectées sont conservées pendant la durée nécessaire à la fourniture du service, et donc à votre
            utilisation du service, augmentée de la durée de conservation imposée par les règles applicables en matière de
            prescription légale. <br><br>
            <p class="text-center">Visitez notre <a
                href="https://pga.acma2.org/politique-confidentialite-IFDC.html#_Toc108606206" target="_blank"
                rel="noopener noreferrer">politique de protection des données personnelles</a>
            </p>

          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <a href="http://www.google.com"><v-btn color="red darken-1">
                TOUT REFUSER
              </v-btn></a>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" @click="acceptCookies()">
              TOUT ACCEPTER
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-layout>
</template>

<script>
import Form from 'vform'
import Permissions from '~/mixins/Permissions'

export default {
  name: 'login-view',
  mixins: [Permissions],
  layout: 'default',
  metaInfo() {
    return { title: this.$t('login') }
  },
  data: () => ({
    form: new Form({
      email: '',
      password: ''
    }),
    privacy: "En vous connectant, vous acceptez nos conditions générales d'utilisation",
    confirm: false,
    confirmation: false,
    eye: true,
    remember: false,
    cookieConsent: false,
    busy: false
  }),

  mounted() {
    this.checkCookieConsent();
  },
  methods: {
    checkCookieConsent() {
      if (!this.getCookie("cookieConsent")) {
        this.cookieConsent = true;
      } else {
        this.cookieConsent = false;
      }
    },
    acceptCookies() {
      this.setCookie("cookieConsent", "false", 180);
      this.cookieConsent = false;
    },
    setCookie(name, value, day) {
      const dateExpiration = new Date();
      dateExpiration.setTime(dateExpiration.getTime() + day * 24 * 60 * 60 * 1000);
      const expires = "expires=" + dateExpiration.toUTCString();
      document.cookie = name + "=" + value + ";" + expires + ";path=/";
    },
    getCookie(name) {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(name + '=')) {
          return cookie.substring(name.length + 1);
        }
      }
      return null;
    },
    async login() {
      if (await this.formHasErrors()) return
      this.busy = true

      if (!this.confirm) {

        this.confirmation = true

      } else
        await this.form.post('/api/auth/login').then(response => {

          if (response.data.status == true) {
            this.saveTokenProfile(response.data)
          } else {
            this.redirectProfileRoute(response.data);
          }
          this.form.reset()
        }).catch(error => {
          this.$store.dispatch('responseMessage', {
            type: 'red',
            text: error.response.data.errors.message
          })
          this.busy = false
        })

    },

    async redirectProfileRoute(data) {
      // Save the token.
      await this.$store.dispatch('saveToken', {
        token: data.access_token,
        remember: this.remember
      })

      // Fetch the user.
      await this.$store.dispatch('fetchUser')
      this.busy = false

      this.$router.push({ name: 'settings.profile' })
    },

    async saveTokenProfile(data) {
      // Save the token.
      this.$store.dispatch('saveToken', {
        token: data.access_token,
        remember: this.remember
      })

      // Fetch the user.
      await this.$store.dispatch('fetchUser')
      this.busy = false

      // Redirect home if authorized
      if (this.$can('access dashboard')) {
        this.$router.push(this.$route.query.redirect || { name: 'overview' })
      } else {
        this.$router.push(
          this.$route.query.redirect || { name: 'about' }
        )
      }
    }
  },
  computed: {
    isConfirm: function () {
      if (this.confirm) {
        this.confirmation = false
      }
      return this.confirmation;
    }
  },
  beforeDestroy() {
    this.$validator.pause()
  }
}
</script>

<style scoped>
.card-login {
  box-shadow: 0px 10px 20px 5px rgba(0, 0, 0, 0.2);
}

.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #78b943;
}</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/auth/login.vue